export const API = {
    url: "https://cms.wicode.io/api",
    img: "https://cms.wicode.io",
}

export const CDS = {
    API: "https://cds.wicode.io/contact",
    API_WITH_ATTACHMENTS: "https://cds.wicode.io/contact/with-attachments",
    GENERAL_KEY: "d045f72a69526f9d923282f35bc212180a1235535887bf171b47a7c6033ea750",
    BEWERBUNGS_KEY: "a33765c78c7773cf24943f360eb286501ef2e314589c98950178e1f6869b490e",
}

export const COOKIE = {
    KEY: "288f55e7-f685-4122-b6cc-cb514c1ca860",
    VALUE: "true",
}

export const GA_TRACKING_ID = "G-2EYM6WWGQB"
